import validator from "validator";

interface Values {
  name: string;
  email: string;
}

export function subscriptionPaymentValidator(values: Values) {
  const errors: any = {};

  if (!values.name) {
    errors.name = "Full name is required.";
  } else if (values.name.trim().length < 3) {
    errors.name = "Full name must have minimum 3 characters.";
  } else if (values.name.trim().length > 25) {
    errors.name = "Full name maximum length should be 25 characters.";
  }

  if (!values.email) {
    errors.email = "Email is required.";
  } else if (!validator.isEmail(values.email.trim())) {
    errors.email = "Email must be a valid email address.";
  }

  return errors;
}
